// import { useSelector } from 'react-redux';
// import { staticComponentValueConverter } from '../StaticComponentValues';

// const MenuList_7 = ({ item }) => {
//   const staticValues = useSelector(state => state.themeSlice?.staticValues);
//   const customization = staticComponentValueConverter(item?.customization);

//   const getLevelStyles = level => {
//     switch (level + 1) {
//       case 1:
//         return {
//           textSize: customization?.levelOneTextSize,
//           textColor: customization?.levelOneTextColor,
//           textWeight: customization?.levelOneTextWeight,
//         };
//       case 2:
//         return {
//           textSize: customization?.levelTwoTextSize,
//           textColor: customization?.levelTwoTextColor,
//           textWeight: customization?.levelTwoTextWeight,
//         };
//       case 3:
//         return {
//           textSize: customization?.levelThreeTextSize,
//           textColor: customization?.levelThreeTextColor,
//           textWeight: customization?.levelThreeTextWeight,
//         };
//       default:
//         return {
//           textSize: customization?.levelFourAndOthersTextSize,
//           textColor: customization?.levelFourAndOthersTextColor,
//           textWeight: customization?.levelFourAndOthersTextWeight,
//         };
//     }
//   };

//   const renderItems = (data, level = 0) => {
//     if (!data || !data.length) return null;

//     return (
//       <div
//         style={{
//           backgroundColor: 'red',
//         }}
//       >
//         {data.map((item, idx) => (
//           <div
//             key={idx}
//             style={{
//               borderBottom: level === 0 ? '1px solid' : '',
//               borderColor: customization?.borderColor || 'black',
//             }}
//           >
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 padding: customization?.padding,
//                 gap: 5,
//               }}
//             >
//               {item.image ? (
//                 <img src={item.image} width={staticValues[20]} height={staticValues[20]} />
//               ) : (
//                 <div
//                   style={{
//                     width: staticValues[20],
//                     height: staticValues[20],
//                   }}
//                 />
//               )}

//               <div
//                 style={{
//                   textAlign: 'start',
//                   flex: 1,
//                   fontSize: getLevelStyles(level)?.textSize,
//                   fontWeight: getLevelStyles(level)?.textWeight,
//                   color: getLevelStyles(level)?.textColor,
//                 }}
//               >
//                 {item.title}
//               </div>

//               <div style={{ paddingRight: staticValues[10] }}>
//                 {item?.children?.length > 0 &&
//                   (idx === 0 ? (
//                     <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none">
//                       <rect width="48" height="48" fill="white" fillOpacity="0.01" />
//                       <path
//                         d="M37 18L25 30L13 18"
//                         stroke={customization?.showAllTextColor}
//                         strokeWidth="4"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   ) : (
//                     <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none">
//                       <rect width="48" height="48" fillOpacity="0.01" />
//                       <path
//                         d="M19 12L31 24L19 36"
//                         stroke={customization?.showAllTextColor}
//                         strokeWidth="4"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   ))}
//               </div>
//             </div>

//             {renderItems(item.children, level + 1)}
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return customization?.items?.length > 0 ? (
//     <div
//       style={{
//         padding: customization?.containerPadding,
//         backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
//         backgroundImage:
//           customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
//       }}
//     >
//       {renderItems(customization?.items)}
//     </div>
//   ) : (
//     <img src={item?.placeholderImage} className="w-full" />
//   );
// };

// export default MenuList_7;

import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { ChildComponents } from '../../DnDChildComponents';

const MenuList_7 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);

  const getLevelStyles = level => {
    switch (level + 1) {
      case 1:
        return {
          textSize: customization?.levelOneTextSize,
          textColor: customization?.levelOneTextColor,
          textWeight: customization?.levelOneTextWeight,
        };
      case 2:
        return {
          textSize: customization?.levelTwoTextSize,
          textColor: customization?.levelTwoTextColor,
          textWeight: customization?.levelTwoTextWeight,
        };
      case 3:
        return {
          textSize: customization?.levelThreeTextSize,
          textColor: customization?.levelThreeTextColor,
          textWeight: customization?.levelThreeTextWeight,
        };
      default:
        return {
          textSize: customization?.levelFourAndOthersTextSize,
          textColor: customization?.levelFourAndOthersTextColor,
          textWeight: customization?.levelFourAndOthersTextWeight,
        };
    }
  };

  const renderItems = (data, level = 0) => {
    if (!data || !data.length) return null;

    return (
      <div>
        {data.map((item, idx) => (
          <div key={idx} style={{ position: 'relative' }}>
            {/* Sadece son olmayan item'lara çizgi çiz */}
            {level === 0 && idx !== data.length - 1 && (
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 50,
                  right: 0,
                  height: '1px',
                  backgroundColor: customization?.borderColor || 'black',
                }}
              />
            )}

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: customization?.padding,
                gap: 5,
              }}
            >
              {item.image ? (
                <img
                  src={item.image}
                  style={{
                    width: staticValues[30],
                    height: staticValues[30],
                  }}
                />
              ) : (
                <div
                  style={{
                    width: staticValues[30],
                    height: staticValues[30],
                  }}
                />
              )}

              <div
                style={{
                  textAlign: 'start',
                  flex: 1,
                  fontSize: getLevelStyles(level)?.textSize,
                  fontWeight: getLevelStyles(level)?.textWeight,
                  color: getLevelStyles(level)?.textColor,
                }}
              >
                {item.title}
              </div>

              <div style={{ paddingRight: staticValues[10] }}>
                {item?.children?.length > 0 &&
                  (idx === 0 ? (
                    <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none">
                      <rect width="48" height="48" fill="white" fillOpacity="0.01" />
                      <path
                        d="M37 18L25 30L13 18"
                        stroke={customization?.showAllTextColor}
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none">
                      <rect width="48" height="48" fillOpacity="0.01" />
                      <path
                        d="M19 12L31 24L19 36"
                        stroke={customization?.showAllTextColor}
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ))}
              </div>
            </div>

            {renderItems(item.children, level + 1)}
          </div>
        ))}
      </div>
    );
  };

  return customization?.items?.length > 0 ? (
    <div
      style={{
        margin: customization?.containerPadding,
        backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
        backgroundImage:
          customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
        borderRadius: customization?.borderRadius,
        boxShadow: ChildComponents[customization?.boxShadow]?.data,
        overflow: 'hidden',
      }}
    >
      {renderItems(customization?.items)}
    </div>
  ) : (
    <img src={item?.placeholderImage} className="w-full" />
  );
};

export default MenuList_7;
